module.exports = __webpack_public_path__ + "img/img-02.25d34768.png";